<template>
    <div v-if="pageCount > 1" class="c c-small c-pagination">
        <div class="c-pagination__previous">
            <span v-if="!hasPreviousPage" class="c-pagination__button c-pagination__button--disabled">
                <i class="fal fa-arrow-left"></i>
            </span>
            <a v-else :href="'?pageNr=' + (currentPage - 1)" rel="prev" class="c-pagination__button" @click.prevent="previousPage()">
                <i class="fal fa-arrow-left"></i>
            </a>
        </div>
        <div class="c-pagination__body">
            <span>Pagina</span>
            <select class="c-pagination__pages" @change="setCurrentPageByEvent($event)">
                <option v-for="n in pageCount" :key="n" :value="n" :selected="n == currentPage">{{ n }}</option>
            </select>
            <span>van {{ pageCount }}</span>
        </div>
        <div class="c-pagination__next">
            <span v-if="!hasNextPage" class="c-pagination__button c-pagination__button--disabled">
                <i class="fal fa-arrow-right"></i>
            </span>
            <a v-else :href="'?pageNr=' + (currentPage + 1)" rel="next" class="c-pagination__button" @click.prevent="nextPage()">
                <i class="fal fa-arrow-right"></i>
            </a>
        </div>
    </div>
</template>
<script>
    export default {    
        props: [ 
            'pageCount',
            'hasPreviousPage',
            'currentPage',
            'hasNextPage'
        ],
        methods:{
            previousPage(){
                this.$parent.previousPage();
            },
            setCurrentPageByEvent($event){
                this.$parent.setCurrentPageByEvent($event);
            },
            nextPage(){
                this.$parent.nextPage();
            }
        }
    };
    </script>
    